import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { UserService } from './services/user.service'
import { SegmentService } from './analytics/services/segment.service'
import { SegmentEvents } from './analytics/models/segment-events.model'

@Component({
  selector: 'flo-claim-account-error',
  // tslint:disable:max-line-length
  template: `
    <a floAnalytics name="Claim Account Error Message" class="error-box claim-account" (click)="redirectClaimAccount()">
      <p class="error-msg"
        >An account tied to this email was transferred from {{ migratedSite }}. Claim your account by
        <span>clicking here</span>.</p
      >
    </a>
  `,
  styles: [
    `
      .error-box.claim-account p.error-msg {
        cursor: pointer;
      }

      .error-box.claim-account p.error-msg span {
        text-decoration: underline;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClaimAccountErrorComponent implements OnInit {
  @Input()
  migratedSite: string
  @Input()
  email: string

  public redirectClaimAccount() {
    this.userService.migratedUserInfoSource.next({
      email: this.email,
      migrated_site: this.migratedSite
    })

    this.router.navigate(['../claim-account'])
  }

  ngOnInit() {
    // Does not use floAnalytic's form-error-service, so needs to be fired manually
    this.segmentService.track(SegmentEvents.ERROR_DISPLAYED, {
      message: `An account tied to this email was transferred from ${this.migratedSite}. Claim your account by clicking here.`
    })
  }

  constructor(private router: Router, private userService: UserService, private segmentService: SegmentService) {}
}
